import React, { useState, useEffect } from "react";
import { sendNoteCreditOfSupplier } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";
import Select from "react-select";
import { WidgetModal } from "../../modules.widgets";

export function NewNoteCreditForm({
    noteCredit,
    setNoteCredit,
    orders,
    initialNoteCreditState,
    isOpen,
    onClose,
    onSave,
}) {
    const inputClass = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
    const labelClass = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";
    
    const filteredOrders = orders
        .filter(
            (o) =>
                o.operationDocumentTypeID === "03" && o.operationStatus === "02"
        )
        .map((o) => ({
            value: o.operationID,
            label: `${o.operationDocumentNumber} | S/ ${Number(
                o.operationAmountTotal
            ).toFixed(2)}`,
        }));
    
    function handleChange(e) {
        const { name, value } = e.target;
        setNoteCredit({ ...noteCredit, [name]: value });
    }
    
    function handleSelectChange(selectedOption) {
        setNoteCredit({
            ...noteCredit,
            purchaseID: selectedOption ? selectedOption.value : "",
        });
    }

    const sendNoteCredit = async (registerData) => {
        try {
            const response = await sendNoteCreditOfSupplier(registerData);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const handleClickBtnSave = async () => {
        if (noteCredit.purchaseID != "0") {
            if (Number(noteCredit.totalCost) >= 0) {
                if (noteCredit.operationDocumentNumber.length > 0) {
                    sendNoteCredit(noteCredit)
                        .then(async (r) => {
                            let data = {
                                operationDocumentNumber:
                                    r.operationDocumentNumber,
                                operationDate: r.operationDate,
                                motive: r.motive,
                                purchaseID: r.purchaseID,
                                totalCost: Number(r.totalCost),
                            };

                            return data;
                        })
                        .then(async (data) => {
                            if (data) {
                                await setNoteCredit(initialNoteCreditState);
                                toast.success(
                                    "Nota de credito registrada con exito!"
                                );
                                if (onSave) onSave();
                            } else {
                                toast.error("Ocurrio algun error");
                            }
                        });

                    onClose();
                } else {
                    toast.error("Verifique el numero de documento");
                }
            } else {
                toast.error("Verifique el monto total");
            }
        } else {
            toast.error("Verifique el doc. de referencia");
        }
    };

    return (
        <WidgetModal isOpen={isOpen} onClose={onClose} title="Nueva Nota de credito" size="sm">
            <div className="p-6">
                <div className="space-y-4">
                    <div>
                        <label className={labelClass}>Num Doc</label>
                        <input
                            type="text"
                            className={inputClass}
                            placeholder="Ingrese ..."
                            name="operationDocumentNumber"
                            maxLength={20}
                            value={noteCredit.operationDocumentNumber}
                            onChange={handleChange}
                            autoComplete="off"
                        />
                    </div>

                    <div>
                        <label className={labelClass}>Motivo:</label>
                        <input
                            type="search"
                            className={inputClass}
                            placeholder="Ingrese ..."
                            name="motive"
                            maxLength={400}
                            value={noteCredit.motive || ""}
                            onChange={handleChange}
                            autoComplete="off"
                            list="motives"
                        />
                        <datalist id="motives">
                            <option value="Cambios Vencidos del Mes" />
                            <option value="Limpieza de Zona" />
                            <option value="Producto Reventados" />
                            <option value="Liquidación General" />
                            <option value="Reconocimiento por Producto gratis" />
                            <option value="Devoluvion por Ítem" />
                            <option value="Disminucion en el Valor" />
                            <option value="Coreccion por error en la Descripción" />
                        </datalist>
                    </div>

                    <div>
                        <label className={labelClass}>Fecha:</label>
                        <input
                            type="date"
                            className={inputClass}
                            name="operationDate"
                            value={noteCredit.operationDate || ""}
                            onChange={handleChange}
                            autoComplete="off"
                        />
                    </div>

                    <div>
                        <label className={labelClass}>Doc. Ref.:</label>
                        <Select
                            options={filteredOrders}
                            className="font-weight-light"
                            placeholder="Elige"
                            onChange={handleSelectChange}
                            value={
                                filteredOrders.find(
                                    (option) =>
                                        option.value === noteCredit.purchaseID
                                ) || null
                            }
                            isClearable
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderRadius: '0.5rem',
                                    borderColor: 'rgb(209 213 219)',
                                    backgroundColor: 'rgb(255 255 255)',
                                    padding: '0.25rem 0.5rem',
                                }),
                            }}
                        />
                    </div>

                    <div>
                        <label className={labelClass}>Total</label>
                        <input
                            type="number"
                            className={inputClass}
                            placeholder="Ingrese ..."
                            name="totalCost"
                            maxLength={6}
                            value={noteCredit.totalCost}
                            onChange={handleChange}
                            autoComplete="off"
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                </div>
            </div>
            
            <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 flex justify-end gap-3">
                <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm font-medium px-4 py-2 transition-colors"
                    onClick={onClose}
                >
                    Cerrar
                </button>
                <button
                    type="button"
                    className="inline-flex items-center gap-1.5 rounded-lg border border-transparent text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 text-sm font-medium px-4 py-2 transition-colors"
                    onClick={handleClickBtnSave}
                >
                    Guardar
                </button>
            </div>
        </WidgetModal>
    );
}
